import axios from '../axios'
import constants from '../constants'

const errMsg = 'Server is unavailable.'
export const getCMSList = token => (dispatch) => {
  axios.get('/cms', { headers: { Authorization: token } }).then((response) => {
    dispatch({
      type: constants.CMS_LIST,
      payload: {
        data: response.data.data,
        resStatus: true
      }
    })
  }).catch(() => {
    dispatch({
      type: constants.CMS_LIST,
      payload: {
        data: [],
        resStatus: false
      }
    })
  })
}

export const getCMSDetails = (slug, token) => (dispatch) => {
  axios.get(`/cms/admin/${slug}`, { headers: { Authorization: token } }).then((response) => {
    dispatch({
      type: constants.CMS_DETAILS,
      payload: {
        data: response.data.data,
        resStatus: true
      }
    })
  }).catch((error) => {
    dispatch({
      type: constants.CMS_DETAILS,
      payload: {
        data: {},
        resStatus: false,
        resMessage: error.response ? error.response.data.message : errMsg
      }
    })
  })
}

export const addCMS = (sSlug, sTitle, sDetails, token) => (dispatch) => {
  dispatch({ type: constants.CLEAR_CMS_MESSAGE })
  axios.post('/cms', {
    sSlug, sTitle, sDetails
  }, { headers: { Authorization: token } }).then((response) => {
    dispatch({
      type: constants.ADD_CMS_DETAILS,
      payload: {
        data: response.data.data,
        resStatus: true,
        resMessage: response.data.message
      }
    })
  }).catch((error) => {
    dispatch({
      type: constants.ADD_CMS_DETAILS,
      payload: {
        data: {},
        resStatus: false,
        resMessage: error.response ? error.response.data.message : errMsg
      }
    })
  })
}

export const editCMS = (id, sSlug, sTitle, sDetails, eStatus, token) => (dispatch) => {
  dispatch({ type: constants.CLEAR_CMS_MESSAGE })
  axios.put(`/cms/${id}`, {
    sSlug, sTitle, sDetails, eStatus
  }, { headers: { Authorization: token } }).then((response) => {
    dispatch({
      type: constants.EDIT_CMS_DETAILS,
      payload: {
        resStatus: true,
        resMessage: response.data.message
      }
    })
  }).catch((error) => {
    dispatch({
      type: constants.EDIT_CMS_DETAILS,
      payload: {
        resStatus: false,
        resMessage: error.response ? error.response.data.message : errMsg
      }
    })
  })
}

export const deleteCMS = (id, token) => (dispatch) => {
  dispatch({ type: constants.CLEAR_CMS_MESSAGE })
  axios.delete(`/cms/${id}`, { headers: { Authorization: token } }).then((response) => {
    dispatch({
      type: constants.DELETE_CMS_DETAILS,
      payload: {
        resStatus: true,
        resMessage: response.data.message
      }
    })
  }).catch((error) => {
    dispatch({
      type: constants.DELETE_CMS_DETAILS,
      payload: {
        resStatus: false,
        resMessage: error.response ? error.response.data.message : errMsg
      }
    })
  })
}
